import { Outlet } from "react-router-dom";
import { React, useState } from "react";
import Navbar from "./components/Navbar";
import { AlertContext } from "./hooks/AlertHook";

function App() {
  const [showAlert, setShowAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState('');
  const [homeLink, setHomeLink] = useState('/auth/login');

  return (
    <AlertContext.Provider value={{
      show: showAlert,
      message: messageAlert,
      homeLink: homeLink,
      setShow: setShowAlert,
      setMessage: setMessageAlert,
      setHomeLink: setHomeLink,
    }}>
      <div>
        <Navbar/>
      </div>
      <Outlet/>
    </AlertContext.Provider>
  );
}

export default App;
